import { assertNever } from "../lib/assertNever";
import { isJust, just, nothing, type Maybe } from "../lib/maybe";

export type Model = { open: boolean; original: Maybe<string>; scene: string };
export const initialModel: Model = {
  open: false,
  original: nothing,
  scene: "",
};
export type Msg =
  | { type: "Create" }
  | { type: "Edit"; scene: string }
  | { type: "EditMap"; mapFile: string; markerId: string }
  | { type: "Change"; scene: string }
  | { type: "Close" }
  | { type: "Save" }
  | { type: "Remove" };
export type Cmd =
  | { kind: "OpenMap"; mapFile: string; markerId: string }
  | { kind: "Save"; original: Maybe<string>; scene: string }
  | { kind: "Remove"; scene: string };
export function update(
  model: Model,
  msg: Msg,
): readonly [Model, readonly Cmd[]] {
  switch (msg.type) {
    case "Create":
      return [{ ...initialModel, open: true }, []];
    case "Edit":
      return [{ open: true, original: just(msg.scene), scene: msg.scene }, []];
    case "EditMap":
      return [
        initialModel,
        [{ kind: "OpenMap", mapFile: msg.mapFile, markerId: msg.markerId }],
      ];
    case "Change":
      return [{ ...model, scene: msg.scene }, []];
    case "Close":
      return [initialModel, []];
    case "Save":
      return model.scene.length === 0
        ? [model, []]
        : [
            initialModel,
            [{ kind: "Save", original: model.original, scene: model.scene }],
          ];
    case "Remove":
      return isJust(model.original)
        ? [initialModel, [{ kind: "Remove", scene: model.original.value }]]
        : [model, []];
    default:
      return assertNever(msg);
  }
}
